export var PRACTICE_SUBMISSION_REPOSITORY = 'PRACTICE_SUBMISSION_REPOSITORY';